import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAquaaMappingAccounts, getAquaaMappingContacttypeForms, getAquaaMappingCountries, getAquaaMappingParameterType, getAquaaMappingQuestions, getAquaaMappingSections, updateAquaaMappingDataStart } from '../../../../actions/Applications/aquaa.action';
// import AdminBreadcrumb from '../../../components/Administration/General/Admin-breadcrumb';
import Filter_Icon from './../../../../assets/images/Filter_Icon.png';
import deleteIcon from './../../../../assets/onboard-images/Delete_Icon.png'
import { TimeOutSelect } from '../../../../components/Onboard/OnboardComponents/Dropdown/TimeOutSelect';
import AdminBreadcrumb from '../../../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom';
import { OnboardSelect } from '../../../../components/Onboard/OnboardComponents/Dropdown/Select';

const AquaaAdminMapping = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const aquaaMappingAccounts = useSelector((state) => state.aquaaReducer.aquaaMappingAccounts);
    const aquaaMappingContacttypeForms = useSelector((state) => state.aquaaReducer.aquaaMappingContacttypeForms);
    const aquaaMappingCountries = useSelector((state) => state.aquaaReducer.aquaaMappingCountries);
    const aquaaMappingSections = useSelector((state) => state.aquaaReducer.aquaaMappingSections);
    const aquaaMappingQuestions = useSelector((state) => state.aquaaReducer.aquaaMappingQuestions);
    const aquaaMappingParameterType = useSelector((state) => state.aquaaReducer.aquaaMappingParameterType);
    const [formData, setFormData] = useState([])
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        dispatch(getAquaaMappingAccounts());
        dispatch(getAquaaMappingContacttypeForms());
        dispatch(getAquaaMappingSections());
        dispatch(getAquaaMappingQuestions());
        dispatch(getAquaaMappingParameterType());
    }, [dispatch])

    const addValueToFormData = (name, selectedOption) => {
        if (name !== 'Select') {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: selectedOption,
            }));
        }
    };

    useEffect(() => {
    if (formData.account_Name && formData.account_Name.account_Name) {
        dispatch(getAquaaMappingCountries(formData.account_Name.account_Name));
        setFormData(prev => ({
            ...prev,
            sitename: '', // reset site selection
        }));
    }
}, [formData.account_Name, dispatch]);

    const HandleAddUser = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        const fieldValue = event.target.value;
        if (fieldValue !== 'Select') {
            const newFormData = { ...formData };
            newFormData[fieldName] = fieldValue;
            setFormData(newFormData)
        }
    }

    const [usernameInfo, setUsernameInfo] = useState([]);

    useEffect(() => {
        setUsernameInfo(aquaaMappingQuestions)
    }, [aquaaMappingQuestions])

    const QueryHandler = query => {
        setTimeout(() => {
            dispatch(getAquaaMappingQuestions(query));
            setUsernameInfo(aquaaMappingQuestions)
        }, 2000)
        if (query === '') {
            dispatch(getAquaaMappingQuestions(''));
        }
    }

    console.log('formData', formData)

    const [submittedData, setSubmittedData] = useState([]);
    // const handleAddToTable = () => {
    //     if (Object.keys(formData).length === 0) return; // Optional: prevent empty rows
    //     setSubmittedData(prev => [...prev, formData]);
    // };

//     const handleAddToTable = () => {
//     if (Object.keys(formData).length === 0) return;

//     // Add current formData to the submitted data list
//     setSubmittedData(prev => [...prev, formData]);

//     // Reset only specific fields
//     setFormData(prevFormData => ({
//         ...prevFormData,
//         question: '',
//         QuestionOrder: '',
//         parameterType: ''
//     }));
// };

const handleAddToTable = () => {
    if (Object.keys(formData).length === 0) return;

    // Check if QuestionOrder already exists
    const isDuplicate = submittedData.some(item => item.QuestionOrder === formData.QuestionOrder);
    if (isDuplicate) {
        setErrorMessage(`Question Order "${formData.QuestionOrder}" already exists.`);
        return;
    }

    setSubmittedData(prev => [...prev, formData]);
    setErrorMessage(''); // clear any previous error

    setFormData(prevFormData => ({
        ...prevFormData,
        question: '',
        QuestionOrder: '',
        parameterType: ''
    }));
};



    const getDisplayValue = (val) => {
        if (val && typeof val === 'object') {
            // Try all known display keys here, add as needed
            return val.account_Name || val.contactTypeForm || val.sitename || val.section || val.parameterType || val.question || val.label || val.name || JSON.stringify(val);
        }
        return val;
    };

    const dispatchObjData = submittedData.map(item => ({
  SectionID: item.section.sectionID,
  AccountID: item.account_Name.id,
  CountryID: item.sitename.countryID,
  ContactTypeID: item.contactTypeForm.id,
  QuestionID: item.question.questionID,
  ParameterTypeID: item.parameterType.id,
  QuestionOrder: item.QuestionOrder
}));

const handleDeleteRow = (indexToDelete) => {
    setSubmittedData(prevData =>
        prevData.filter((_, index) => index !== indexToDelete)
    );
};

    return (
        <Fragment>
            <div>
            <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={true}
        value3={() => history.push('/aquaaadminonboardlanding')} label3='AQuAA Admin' isActive4={false} label4='Mapping'/>
                <section className='App_Layout'>
                    <main className='Title_bar'> <div className='Applications_Title'> Mapping </div></main>
                </section>
                <section className='Filter_aquaa'>
                    <main className='aquaa_filter_img'>
                        <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '70px', paddingLeft: '30px' }} />
                    </main>
                    <div className='aquaaFilterAlignment'>
                        <main className='Aquaa_dropdown'>
                            <label HtmlFor='account'>Account</label>
                            <OnboardSelect data={aquaaMappingAccounts} name='account_Name' value='account_Name' id='id' marginTop='10px'
                                editValue='' addValueToQueue={addValueToFormData} passFullObject={true} />
                        </main>
                        <main className='Aquaa_dropdown'>
                            <label HtmlFor='contacttypeform'>ContactType Form</label>
                            <OnboardSelect data={aquaaMappingContacttypeForms} name='contactTypeForm' value='contactTypeForm' id='id' marginTop='10px'
                                editValue='' addValueToQueue={addValueToFormData} passFullObject={true} />
                        </main>
                        <main className='Aquaa_dropdown'>
                            <label HtmlFor='contacttypeform'>Site</label>
                            <OnboardSelect data={aquaaMappingCountries} name='sitename' value='sitename' id='countryID' marginTop='10px'
                                editValue='' addValueToQueue={addValueToFormData} passFullObject={true} />
                        </main>
                        <main className='Aquaa_dropdown'>
                            <label HtmlFor='contacttypeform'>Section</label>
                            <OnboardSelect data={aquaaMappingSections} name='section' value='section' id='sectionID' marginTop='10px'
                                editValue='' addValueToQueue={addValueToFormData} passFullObject={true} />
                        </main>
                        <main className='Aquaa_dropdown'>
                            <label>Section Order</label>
                            <input type='text'
                                name='SectionOrder'
                                value={formData?.SectionOrder}
                                placeholder='Example: 1'
                                onChange={(e) => HandleAddUser(e)}
                            />
                        </main>

                        <main className='Aquaa_dropdown' style={{ width: '70%' }}>
                            <label HtmlFor='contacttypeform'>Questions</label>
                            <TimeOutSelect data={usernameInfo} name='question' value='question' id='questionID'
                                QueryHandler={QueryHandler} addValueToQueue={addValueToFormData} passFullObject={true} editValue={formData?.question}/>
                        </main>
                        <main className='Aquaa_dropdown'>
                            <label HtmlFor='parametertype'>ParameterType</label>
                            <OnboardSelect data={aquaaMappingParameterType} name='parameterType' value='parameterType' id='id' marginTop='10px'
                                editValue={formData?.parameterType} addValueToQueue={addValueToFormData} passFullObject={true} />
                        </main>

                        <main className='Aquaa_dropdown'>
                            <label>Question Order</label>
                            <input type='text'
                                name='QuestionOrder'
                                value={formData?.QuestionOrder}
                                placeholder='Example: 1'
                                onChange={(e) => HandleAddUser(e)}
                            />
                           
                        </main>
                        <div className='btn_adduser' onClick={() => handleAddToTable()}>
                            ADD
                        </div>

                    </div>
                </section>
                 {errorMessage && (
    <div style={{ color: 'red', marginTop: '20px', textAlign: "left" }}>
        {errorMessage}
    </div>
)}

                {submittedData.length > 0 && (
                    <table className="aquaa-table" style={{marginTop:'30px'}}>
                        <thead>
                            <tr>
                                {Object.keys(submittedData[0]).map((key) => (
                                    <th key={key}>{key}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {submittedData.map((entry, index) => (
                                <tr key={index}>
                                    {Object.entries(entry).map(([key, value]) => (
                                        <td key={key}>
                                            {getDisplayValue(value)}
                                        </td>
                                    ))}
                                     <td>
                <img src={deleteIcon} alt='' onClick={() => handleDeleteRow(index)} style={{cursor:"pointer"}}/>
            </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
{submittedData.length > 0 && <div style={{display:'flex',justifyContent:'center'}}><div className='btn_adduser' onClick={()=>{dispatch(updateAquaaMappingDataStart(dispatchObjData));history.push('/aquaaadminonboardlanding')}}>Submit</div></div>}
            </div>
        </Fragment>
    )
}

export default AquaaAdminMapping